// @ts-ignore
import { NotificationLogClient } from '@atlaskit/notification-log-client';

class EmptyNotificationLogClient extends NotificationLogClient {
  constructor() {
    super('', '');
  }

  // @ts-ignore
  countUnseenNotifications() {
    return Promise.resolve({ count: 0 });
  }
}

export default EmptyNotificationLogClient;
